import { render, staticRenderFns } from "./StepIndicator.vue?vue&type=template&id=4a06f866&scoped=true"
import script from "./StepIndicator.vue?vue&type=script&lang=ts"
export * from "./StepIndicator.vue?vue&type=script&lang=ts"
import style0 from "./StepIndicator.vue?vue&type=style&index=0&id=4a06f866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a06f866",
  null
  
)

export default component.exports